import { statusTokens } from "../domain/status";
import type { CompanyStatus } from "../domain/status";
import { nl } from "../i18n/nl";
import styles from "./StatusChip.module.css";
import { StatusGlyph } from "./StatusGlyph";

/** Status pill: glyph + label on the status tint. */
export function StatusChip({ status }: { status: CompanyStatus }) {
  const { fg, bg } = statusTokens(status);
  return (
    <span className={styles.chip} style={{ color: fg, background: bg }}>
      <StatusGlyph status={status} size={13} />
      {nl.status[status]}
    </span>
  );
}
